import { css } from '@linaria/atomic';
import { FallbackRender } from '@sentry/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Modal, Text, useModalControl } from '@frontend/design-system';
import { ErrorDetails, ErrorMessage } from './common';

const topBarBoundaryDivStyle1 = css`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  padding: ${`${theme.spacing(2)} ${theme.spacing(3)}`};
  border-bottom: ${`1px solid ${theme.colors.neutral20}`};
`;

export const TopBarBoundary: FallbackRender = ({ error, eventId, resetError }) => {
  const { t } = useTranslation('base');
  const { triggerProps, modalProps } = useModalControl();

  if (!(error instanceof Error)) {
    return <Text weight='bold'>{t('Something went wrong.')}</Text>;
  }
  return (
    <div className={topBarBoundaryDivStyle1}>
      <ErrorMessage error={error} />

      <div style={{ display: 'grid', gridAutoFlow: 'column', gap: theme.spacing(1) }}>
        <Button variant='tertiary' {...triggerProps}>
          {t('View Details')}
        </Button>
        <Button onClick={resetError}>{t('Try again')}</Button>
      </div>
      <Modal {...modalProps}>
        <Modal.Header onClose={modalProps.onClose}>{t('Error Details')}</Modal.Header>
        <Modal.Body>
          <ErrorMessage>{error.message}</ErrorMessage>
          <ErrorDetails error={error} eventId={eventId} />
        </Modal.Body>
        <Modal.Footer secondary={{ label: 'Close', onClick: modalProps.onClose }} />
      </Modal>
    </div>
  );
};
